<template>
  <div>
    <el-dialog center width="80%" class="abow_dialog" :close-on-click-modal="false" :before-close="closeDialog" :visible.sync="visible">
      <div>
        <iframe :src="cpsHtml" width="100%" height="500px" frameborder="0"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ServiceAgreement',
  props: {
    visible: Boolean,
  },
  data() {
    return {
      cpsHtml: '/cps.html',
    }
  },
  methods: {
    // 关闭
    closeDialog(){
      this.$emit('closeDialog')
    },
  }
}
</script>

<style lang="less" scoped>
// @import './cps_style.less';
::v-deep .el-dialog__header {
  border: none !important;
}
</style>